var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E34E26",
    d: "M352.732 1718.4 208.627 101.984h1582.746l-144.28 1616.544-647.478 179.488z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF662A",
    d: "M1000 234.108v1526.608l523.565-145.131 123.353-1381.477z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m503.468 432.378 53.438 599.519h687.142l-23.06 257.144-221.244 59.816-220.825-59.729-14.764-165.111h-199l28.456 318.285 406.086 112.784 406.599-112.784 54.51-608.633H738.229l-18.143-203.021h758.687l17.759-198.27z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EBEBEB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 432.378H503.468l53.438 599.519H1000V833.669H738.229l-18.143-203.021H1000zM1000 1348.771l-.256.086-220.825-59.729-14.764-165.111h-199l28.456 318.285 406.086 112.784.303-.085z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.de460a734d6e8f8c3bac06f0e8e4e509.svg";
export { ForwardRef as ReactComponent };